<a class="speedy-link {{ type }}" [sRouterLink]="url" translate>{{ text }}</a>
